import { render } from "./CollectionManager.vue?vue&type=template&id=fffa46d4&scoped=true"
import script from "./CollectionManager.vue?vue&type=script&lang=js"
export * from "./CollectionManager.vue?vue&type=script&lang=js"

import "./CollectionManager.vue?vue&type=style&index=0&id=fffa46d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fffa46d4"]])

export default __exports__